<template>
    <div class="detail">
        <el-dialog title="详情" :visible.sync="dialogVisible" width="960px" :before-close="handleClose">
            <div class="content">
                <el-form ref="form" label-width="100px" label-position="left" v-if="info" v-loading="load">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="编号ID：">
                                <p>{{ info.id }}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="预警时间：">
                                <p>{{ info.create_time }}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="品牌名称：">
                                <p>{{ info.brand_name }}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="监控类型：">
                                <p>商品价格</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="监控平台：">
                                <p>{{ info.plateform_list | arrFmt }}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="商品名称：">
                                <p>{{ info.product_name }}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="echarts">
                    <div class="selectDate">
                        <el-radio-group v-model="dateVal" size="mini" @change="dateChange">
                            <el-radio-button :label="30">30天</el-radio-button>
                            <el-radio-button :label="60">60天</el-radio-button>
                            <el-radio-button :label="90">90天</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div id="myChart" style="width: 100%; height: 400px"></div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
let echarts = require("echarts");
export default {
    data() {
        return {
            load: false,
            dialogVisible: false,
            info: {
                name: "",
                brand_name: "",
                spec_name: "",
                plateform_list: "",
                status: "",
            },
            platform_list: [],
            date_list: [],
            id_list: "",
            series: [],
            dateVal: 30,
        };
    },
    filters: {
        arrFmt(val) {
            if (val && val.length > 0) {
                let arr = val.map((item) => {
                    return item.name;
                });
                return arr.toString();
            }
            return "-";
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            detailReportCompeteProduct: "brand/detailReportCompeteProduct",
            getReporCompeteProductchart: "brand/getReporCompeteProductchart",
        }),
        dateChange(val) {
            this.platform_list = [];
            this.date_list = [];
            this.series = [];
            this.getEcharts();
        },
        handleClose() {
            this.platform_list = [];
            this.date_list = [];
            this.id_list = "";
            this.series = [];
            this.dateVal = 30;
            this.dialogVisible = false;
        },
        getInfo(id) {
            this.load = true;
            let params = {
                id: id,
                token: this.getToken,
            };
            this.detailReportCompeteProduct(params).then(({ data }) => {
                this.load = false;
                if (data.code == 1) {
                    this.info = data.data;
                    if (this.info.plateform_list.length > 0) {
                        this.id_list = this.info.plateform_list.map((item) => {
                            return item.id;
                        });
                    }
                    this.getEcharts();
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        getEcharts() {
            let opt = {
                token: this.getToken,
                id: this.info.id,
                days: this.dateVal,
                platform_ids: this.id_list.toString(),
            };
            this.getReporCompeteProductchart(opt).then(({ data }) => {
                if (data.code == 1) {
                    this.date_list = data.data.map((item) => {
                        return item.valDate;
                    });
                    this.platform_list = data.data[0].valData.map((item) => {
                        return item.platform_name;
                    });
                    this.platform_list.forEach((item) => {
                        let obj = {
                            symbol: "none",
                            name: item,
                            type: "line",
                            data: [],
                            price: [],
                        };
                        data.data.forEach((v) => {
                            let val = v.valData.filter((o) => {
                                return o.platform_name == item;
                            });
                            obj.price.push({ discount_price: val[0].discount_price, default_price: val[0].default_price });
                            obj.data.push(val[0].default_price);
                        });
                        this.series.push(obj);
                    });
                    this.drawLine();
                }
            });
        },
        drawLine() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(document.getElementById("myChart"), "light");
            let option = {
                tooltip: {
                    trigger: "axis",
                    formatter: function (params) {
                        var res = params[0].name + "<br/>";
                        var myseries = option.series;
                        let i;
                        option.xAxis.data.forEach((it, index) => {
                            if (params[0].name == it) {
                                i = index;
                            }
                        });
                        params.forEach((item) => {
                            res += item.seriesName + "&nbsp;&nbsp;&nbsp;&nbsp;";
                            myseries.forEach((v) => {
                                if (item.seriesName == v.name) {
                                    res += `面价：${v.price[i].default_price}&nbsp;&nbsp;&nbsp;&nbsp;券后价：${v.price[i].discount_price}` + "<br/>";
                                }
                            });
                        });
                        return res;
                    },
                },
                legend: {
                    data: this.platform_list,
                    orient: "horizontal",
                    icon: "pin",
                    show: true,
                    x: "center",
                    top: 10,
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: this.date_list,
                },
                yAxis: {
                    type: "value",
                },
                series: this.series,
            };
            // 绘制图表
            myChart.setOption(option,true);
        },
    },
};
</script>
<style lang="scss" scoped>
.detail {
    .content {
        min-height: 300px;
        max-height: 450px;
        overflow-y: auto;
        overflow-x: hidden;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
    }
    .echarts {
        position: relative;
        .selectDate {
            position: absolute;
            right: 40px;
            top: 6px;
            z-index: 99;
        }
    }
}
#myChart {
    & > div {
        width: 100% !important;
    }
}
</style>
